/**
 * ciclo-recently-viewed.js
 * ─────────────────────────
 * Records the current product in localStorage and renders a
 * "Recently Viewed" grid using the Shopify product AJAX API.
 *
 * Storage key : 'ciclo_rv'
 * Format      : JSON array of product handles, newest first, max 10
 * Displayed   : up to 6 products excluding the current one
 *
 * No dependencies. Runs with defer.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ciclo_rv';
  var MAX_STORED   = 10;
  var MAX_SHOWN    = 6;
  var SECTION_SEL  = '#ciclo-recently-viewed';
  var GRID_SEL     = '.ciclo-rv__grid';

  var section = document.querySelector(SECTION_SEL);
  if (!section) return;

  var currentId  = section.dataset.currentId;
  var currentUrl = section.dataset.currentUrl;

  // ── 1. Record current product handle in localStorage ──────────────────
  function recordCurrent() {
    var handle = currentUrl.replace(/^\/products\//, '').split('?')[0];
    var stored = readStored();
    // Remove if already present (will re-add at front)
    stored = stored.filter(function (h) { return h !== handle; });
    stored.unshift(handle);
    if (stored.length > MAX_STORED) stored = stored.slice(0, MAX_STORED);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) { /* private browsing / storage full */ }
  }

  function readStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  // ── 2. Fetch and render previously-viewed products ─────────────────────
  function renderRail() {
    var stored  = readStored();
    var current = currentUrl.replace(/^\/products\//, '').split('?')[0];
    // Exclude current and take up to MAX_SHOWN
    var handles = stored.filter(function (h) { return h !== current; }).slice(0, MAX_SHOWN);
    if (handles.length === 0) return;

    var grid     = section.querySelector(GRID_SEL);
    var fetched  = 0;
    var products = [];

    handles.forEach(function (handle, idx) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) products[idx] = p;
        })
        .catch(function () { /* ignore 404s */ })
        .finally(function () {
          fetched++;
          if (fetched === handles.length) renderCards(products, grid);
        });
    });
  }

  function renderCards(products, grid) {
    var cards = products.filter(Boolean);
    if (cards.length === 0) return;

    var html = '';
    cards.forEach(function (p) {
      var img    = p.featured_image
        ? '<img src="' + p.featured_image + '" alt="' + escHtml(p.title) + '" class="ciclo-rv__img" loading="lazy">'
        : '';
      var price  = formatMoney(p.price);
      html +=
        '<a href="/products/' + p.handle + '" class="ciclo-rv__card" role="listitem">' +
          '<div class="ciclo-rv__img-wrap">' + img + '</div>' +
          '<div class="ciclo-rv__info">' +
            (p.vendor ? '<span class="ciclo-rv__vendor">' + escHtml(p.vendor) + '</span>' : '') +
            '<span class="ciclo-rv__name">'  + escHtml(p.title) + '</span>' +
            '<span class="ciclo-rv__price">' + price + '</span>' +
          '</div>' +
        '</a>';
    });

    grid.innerHTML = html;
    section.classList.remove('ciclo-rv--hidden');
  }

  // ── Helpers ────────────────────────────────────────────────────────────
  function formatMoney(paise) {
    // Shopify prices are in the smallest currency unit (paise for INR)
    var rupees = paise / 100;
    return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Run ────────────────────────────────────────────────────────────────
  // Render first (uses data from before current visit), then record current
  renderRail();
  recordCurrent();
})();
